module.exports = __webpack_public_path__ + "img/weather.min.91964033cad04415798d20cb34154384.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/weather.min.svg
// module id = 170
// module chunks = 0